import type { RouteObject } from 'react-router';
import { AppLayout } from '@/app/layouts/AppLayout';
import { PublicLayout } from '@/app/layouts/PublicLayout';
import { RequireAdmin } from '@/app/guards/RequireAdmin';
import { RequireAuth } from '@/app/guards/RequireAuth';
import { IndexRedirect } from '@/routes/IndexRedirect';
import { ForbiddenRoute } from '@/routes/ForbiddenRoute';
import { NotFoundRoute } from '@/routes/NotFoundRoute';
import { LoginRoute } from '@/routes/login/LoginRoute';
import { DashboardRoute } from '@/routes/dashboard/DashboardRoute';
import { ExpensesListRoute } from '@/routes/expenses/ExpensesListRoute';
import { NewExpenseRoute } from '@/routes/expenses/NewExpenseRoute';
import { NewExpenseManualRoute } from '@/routes/expenses/NewExpenseManualRoute';
import { NewExpenseScanRoute } from '@/routes/expenses/NewExpenseScanRoute';
import { ExpenseDetailRoute } from '@/routes/expenses/ExpenseDetailRoute';
import { ExpenseEditRoute } from '@/routes/expenses/ExpenseEditRoute';
import { ReportsRoute } from '@/routes/reports/ReportsRoute';
import { UsersRoute } from '@/routes/admin/UsersRoute';

export const appRoutes: RouteObject[] = [
  { path: '/', element: <IndexRedirect /> },
  { path: '/login', element: <PublicLayout><LoginRoute /></PublicLayout> },
  { path: '/forbidden', element: <PublicLayout><ForbiddenRoute /></PublicLayout> },
  {
    element: <RequireAuth><AppLayout /></RequireAuth>,
    children: [
      { path: '/dashboard', element: <DashboardRoute /> },
      {
        path: '/expenses',
        element: <ExpensesListRoute />,
        children: [
          { path: ':expenseId', element: <ExpenseDetailRoute /> },
        ],
      },
      { path: '/expenses/new', element: <NewExpenseRoute /> },
      { path: '/expenses/new/manual', element: <NewExpenseManualRoute /> },
      { path: '/expenses/new/scan', element: <NewExpenseScanRoute /> },
      { path: '/expenses/:expenseId/edit', element: <ExpenseEditRoute /> },
      { path: '/reports', element: <ReportsRoute /> },
      { path: '/admin/users', element: <RequireAdmin><UsersRoute /></RequireAdmin> },
    ],
  },
  { path: '*', element: <PublicLayout><NotFoundRoute /></PublicLayout> },
];
